import { ApolloProvider } from '@apollo/client/react';
import '@swisscom/sdx/dist/css/webcomponents.css';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { defineCustomElements } from '@swisscom/sdx/dist/js/webcomponents/loader';
import { useEffect } from 'react';

import { useApolloClient } from 'hooks';
import PageTemplate from 'pages/PageTemplate';
import Routes from 'routes/App';
import HelmetTitle from 'utils/HelmetTitle';

const App = () => {
  // SDX
  useEffect(() => void defineCustomElements(), []);

  const client = useApolloClient();

  return (
    <main>
      <HelmetProvider>
        <HelmetTitle />
        {client && (
          <ApolloProvider client={client}>
            <PageTemplate>
              <Routes />
            </PageTemplate>
          </ApolloProvider>
        )}
      </HelmetProvider>
    </main>
  );
};
export default App;
